const breadCrumb = "Lotação de Servidores - Manutenção de Servidores";
const parentRoute = "/cadastro-de-servidor";

const routes = [
  {
    path: "/servidor/:servidorId/codigo-inep-servidor",
    name: "codigo-inep-servidor",
    meta: {
      allowedPermissions: ["servidor_update_inep"],
      breadCrumb: breadCrumb,
      parentRoute: parentRoute,
      pageTitle: "Código Inep do Servidor",
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/ManutencaoDoCodigoInepDoServidor/ManutencaoDoCodigoInepDoServidor.vue"
      ),
  },
];

export default routes;
